export const API_CONFIG = {
  baseUrl: process.env.NODE_ENV === 'production' 
    ? 'https://mentra-backend-dk4r.onrender.com' 
    : 'http://localhost:8000',
  timeout: 10000,
  retries: 3
};
